module.exports = __webpack_public_path__ + "static/img/foodtruckpicedit.75e9d6a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/foodtruckpicedit.png
// module id = gAdS
// module chunks = 1